import React from "react";
import { BuyerAssuranceLayout } from "./assets/style";
import { BuyerAssuranceConfig } from "./@types";
import { Text } from "@nykaa/payment-ui/src/Text";
import { Icon } from "@nykaa/payment-ui/src/Icon";


export const BuyerAssurance = ({ text, htmlText, icon, theme, className }: BuyerAssuranceConfig) => {
  if (!theme) {
    return null;
  }

  return (
    <BuyerAssuranceLayout justifyCenter={!icon} className={className}>
      <Text
        text={text}
        htmlText={htmlText}
        font={theme.typography.bodySmall}
        color={theme?.colors?.textPrimary064}
      />
      {icon && <Icon icon={icon} theme={theme} />}
    </BuyerAssuranceLayout>
  );
};
